import React from 'react';

const Icon170OrientationConfiguration3Recliner = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <g>
      <rect
        x="503.18"
        y="261.8"
        width="216.75"
        height="216.75"
        transform="translate(1223.1 740.34) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M729.1,209.55h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        transform="translate(1481.7 688.09) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M503.18,209.55h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        transform="translate(1223.1 471.34) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M503.18,478.54h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <rect
        x="286.43"
        y="261.8"
        width="216.75"
        height="216.75"
        transform="translate(789.6 740.34) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M286.43,209.55h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        transform="translate(789.6 471.34) rotate(-180)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M286.43,478.54h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
    </g>
    <g>
      <rect
        x="69.68"
        y="261.8"
        width="216.75"
        height="216.75"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M37.01,209.55h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M78.68,209.55h198.75c4.97,0,9,4.03,9,9v43.25H69.68v-43.25c0-4.97,4.03-9,9-9Z"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M78.68,478.54h198.75c4.97,0,9,4.03,9,9v43.25H69.68v-43.25c0-4.97,4.03-9,9-9Z"
        transform="translate(356.11 1009.33) rotate(180)"
        fill="transparent"
        stroke="currentColor"
        strokeDasharray="15"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
    </g>
    <line
      x1="503.18"
      y1="261.8"
      x2="503.18"
      y2="478.54"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon170OrientationConfiguration3Recliner;
